export enum NumberTypes {
    B2B = 'B2B',
    B2C = 'B2C'
}

export const NUMBER_MAP = {
    [NumberTypes.B2B]: 'service-whatsapp.b2b',
    [NumberTypes.B2C]: 'service-whatsapp.b2c'
}


// WEBPACK FOOTER //
// ./ts/app/header/live-agent-support/support-number-map.ts